import { createSlice } from '@reduxjs/toolkit'

export const StripeSlice = createSlice({
  name: 'stripe',
  initialState: {
    value: {},
  },
  reducers: {
    updateStripeTokenDetails: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateStripeTokenDetails } = StripeSlice.actions

export default StripeSlice.reducer